module.exports = __webpack_public_path__ + "static/media/251-samoa.85f054eb.svg";